export enum RetailLocationMicroStoreWorkspaceCapabilityAccessOperation {
    create = "0ae2463b-8f0a-4512-b4d1-d03d0d1c4bf7",
    read = "2ff32284-1453-4f4c-9798-4fb79e94d2b7",
    update = "9c04aa4e-4bbb-4f29-bcad-abd5a91a11ab",
    delete = "0729d719-db3b-48a1-aa08-6e396e7a58d0",
}
